<template>
	<v-app-bar
		app
		class="v-app-bar"
		color="backgroundOryx"
		ref="appBar"
		elevation="0"
		style="border-bottom: 1px solid #cfcfca !important"
	>
		<v-app-bar-nav-icon
			@click="parameters.miniLeftMenu = !parameters.miniLeftMenu"
		></v-app-bar-nav-icon>

		<v-toolbar-title
			class="font-weight-bold title text-grey text--darken-1"
			style="font-family: Muli !important"
			>{{ title }}</v-toolbar-title
		>
		<v-spacer></v-spacer>
		<v-btn color="secondary" outlined @click="$router.push('/indique-e-ganhe')">
			<v-list-item-icon class="mr-2 my-2">
				<v-icon size="28">mdi-circle-multiple</v-icon>
			</v-list-item-icon>
			<v-list-item-title class="caption">
					<h3>Indique e ganhe!</h3>
			</v-list-item-title>
		</v-btn>
		<v-spacer></v-spacer>
		<AppbarTerminal />
		<v-menu offset-y :nudge-width="130">
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="px-2" v-bind="attrs" v-on="on" elevation="0" icon>
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>
			<v-list>
				<v-list-item @click="logoff()">
					<v-list-item-icon>
						<v-icon>mdi-logout</v-icon>
					</v-list-item-icon>
					<v-list-item-title>Sair</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import AppbarTerminal from "@/views/base/header/AppbarTerminal.vue";

export default {
	computed: {
		parameters: {
			get() {
				return this.$store.state.parameters;
			},
		},
		...mapGetters({
			getDc0nome: "parameters/getDc0nome",
		}),
		title() {
			if (this.$route.meta.title) return this.$route.meta.title;
			if (this.getDc0nome) return this.getDc0nome;

			return "ORYX PDV";
		},
	},
	components: {
		AppbarTerminal,
	},
    methods:{
        logoff(){
            this.$store.dispatch("dc4/logoff");
        }
    }
};
</script>

<style scoped>
.v-app-bar {
	/* z-index: 10; */
}
.v-app-bar >>> .v-toolbar__extension {
	padding: 0px !important;
}
</style>
